import { Box, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import React from 'react'

interface CTLoginFlowBenefitsProps {
    // No props needed currently as it uses internal translations
}

export const CTLoginFlowBenefits: React.FC<CTLoginFlowBenefitsProps> = () => {
    const t = useTranslations('otpModal')

    return (
        <>
            {/* Cleartrip Flow: Welcome Section */}
            <Box>
                <Typography variant="h5" sx={{ fontWeight: 600, mb: 1.5, fontSize: 24 }}>
                    {t('cleartripLoginFlow.signUpAndSave.title')}
                </Typography>

                <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5, fontSize: 16, lineHeight: 1.4 }}>
                        {t('cleartripLoginFlow.signUpAndSave.description')}
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: 13, opacity: 0.9, lineHeight: 1.6 }}>
                        {t('cleartripLoginFlow.logInForMorePerks.headerDescription')}
                    </Typography>
                </Box>
            </Box>

            {/* Cleartrip Flow: Perks Section */}
            <Box>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, fontSize: 16 }}>
                    {t('cleartripLoginFlow.logInForMorePerks.title')}
                </Typography>
                <Box component="ul" sx={{ pl: 0, m: 0, listStyle: 'none' }}>
                    {[
                        t('cleartripLoginFlow.logInForMorePerks.benefits.0'),
                        t('cleartripLoginFlow.logInForMorePerks.benefits.1'),
                        t('cleartripLoginFlow.logInForMorePerks.benefits.2'),
                        t('cleartripLoginFlow.logInForMorePerks.benefits.3'),
                        t('cleartripLoginFlow.logInForMorePerks.benefits.4')
                    ].map((benefit: string, index: number) => (
                        <Box
                            component="li"
                            key={index}
                            sx={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                mb: 1.25,
                                '&:last-child': { mb: 0 }
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: 13,
                                    fontWeight: 400,
                                    color: 'common.white',
                                    lineHeight: 1.5,
                                    pl: 2,
                                    position: 'relative',
                                    '&::before': {
                                        content: '"•"',
                                        position: 'absolute',
                                        left: 0,
                                        fontSize: 16,
                                        lineHeight: 1.2
                                    }
                                }}
                            >
                                {benefit}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
        </>
    )
}
